import React from 'react'
// import moment from 'moment';

import { defPath } from '../../config/defPath'

const Bouncer = require('formbouncerjs')
declare global {
  interface Window {
    moment: any
  }
}

const OPTIONS: Intl.DateTimeFormatOptions = {
  year: 'numeric', month: 'short', day: 'numeric',
  hour: 'numeric', minute: 'numeric'
};

const Predict = ({ matchesList, handlePredictionPost, loading }: any) => {

  const [predictions, setPredictions] = React.useState<any[]>([])

  function handleCardClick(e: any) {
    const card = e.currentTarget
    const target: HTMLElement = e.target
    let now
    let gameTime = new Date(card.getAttribute("data-date"))
    // let gameTime = new Date("2023-04-24 11:12:00")
    if (window.moment()) now = new Date(window.moment().format())

    let difference = gameTime.getTime() - now.getTime()
    let minutes = Math.floor(difference / 1000 / 60)


    if (minutes <= 9) {
      const inputs = card.querySelectorAll("input")
      inputs.forEach((input: any, index: any) => {
        if (!input.getAttribute("disabled")) {
          input.setAttribute("disabled")
          input.classList.remove("error")
        }
      });

      if (inputs.length > 0) {
        inputs.forEach((element: any) => {
          if (element.value !== "") {
            const parent = element.closest(".ar__predictions__match__score__scoreboard__box")
            const dataTeam = element.getAttribute("data-team")
            const newText = document.createElement('p')
            newText.classList.add("subtitleSmall", "yellowShadow")
            newText.textContent = element.value
            newText.setAttribute("data-team", `${dataTeam}`)
            parent.replaceWith(newText)
          }
        });
      }
      return
    }

    if (minutes >= 10) {
      const inputs = card.querySelectorAll("input")

      inputs.forEach((input: HTMLInputElement, index: any) => {
        if (input.getAttribute("disabled") !== null) {
          input.style.pointerEvents = 'all'
          input.removeAttribute("disabled")
          input.setAttribute("required", "")
          input.setAttribute("data-state", "")
        }
      });

      target?.querySelector('input')?.focus()
    }
  }

  function handleInputChange(e: any) {
    // console.log("Entra")
    const btn = document.querySelector(".ar__predictions__save")
    const isValid = e.target.validity.valid;
    if (!isValid) e.target.value = ""
    btn?.classList.add("showBtn")

    // quitar clase error
    e.target.classList.remove("error")
  }

  function handleCardBlur(e: any) {
    const card = e.currentTarget
    const form = card.querySelector("form")
    let bouncer = new Bouncer();
    let areValid = bouncer.validateAll(form);
    let isPrediction = false

    if (areValid.length <= 0) {
      let currentState = card?.getAttribute("data-state")
      if (currentState !== "prediction") {
        card.setAttribute("data-state", "newPrediction")
      }

      let match_id = card.getAttribute("id")
      let home = form.querySelector("input[data-team='home']")?.value
      let away = form.querySelector("input[data-team='away']")?.value
      let nameHome = card.querySelector("p[data-nameteam='home']")?.textContent
      let nameAway = card.querySelector("p[data-nameteam='away']")?.textContent
      let league = card.querySelector(".ar__predictions__match__score__league")?.textContent
      let season_id = card.getAttribute("data-season-id")
      const newPrediction = {
        match_id,
        home,
        away,
        nameHome,
        nameAway,
        league,
        season_id
      }

      if (predictions.length <= 0) {
        setPredictions(current => [...current, newPrediction])
        return
      }

      predictions.forEach((prediction) => {
        if (prediction.match_id === match_id) {
          isPrediction = true
          prediction.home = home
          prediction.away = away
        }
      }
      )

      !isPrediction && setPredictions(current => [...current, newPrediction])
    }
  }

  return (
    <>
      {/* CARDS CARDS CARDS */}
      <div className="ar__predictions__matches">
        {
          matchesList?.map((match: any) => (
            <div
              key={match.match_id}
              id={match.match_id}
              data-date={match.match_date}
              onClick={(e) => handleCardClick(e)}
              onBlur={handleCardBlur}
              className="ar__predictions__match ar__predictions__match--prediction blur-in"
              data-season-id={match.season_id}
              data-state={match.home ? "prediction" : "withoutPrediction"} >
              <div className="ar__predictions__match__row">
                {/* equipo home */}
                <div className="ar__predictions__match__box">
                  <div className="ar__predictions__match__team">
                    <img src={`${match.team_home_image}`} alt={match.team_home_name} title={match.team_home_name} />
                    <div className="ar__predictions__match__team__name">
                      <p className='smallText opacity' data-nameteam='home'>{match.team_home_name}</p>
                    </div>
                  </div>

                  { match.goal_home &&
                    <div className="ar__predictions__match__point">
                      <p className='title_2' data-nameteam='home'>
                        {match.goal_home}
                      </p>
                    </div>
                  }
                </div>

                {/* ESTADO SIN PREDICCION */}
                <div className="ar__predictions__match__score">
                  <div className="ar__predictions__match__score__header">
                    <p className="ar__predictions__match__score__league black_20 opacity">
                      {match.season_name}
                    </p>
                    <p className="ar__predictions__match__score__state black_30">
                      {new Intl.DateTimeFormat('es', OPTIONS).format(new Date(match.match_date))}
                    </p>
                  </div>
                  <form className="ar__predictions__match__score__scoreboard">
                    <div className="ar__predictions__match__score__scoreboard__row" data-score>
                      {match.home
                        ? (
                          <div className="ar__predictions__match__score__scoreboard__box">
                            <input style={{pointerEvents: 'none'}} data-initial={`${match.home}`} type="text" name="scoreboard" onChange={(e) => handleInputChange(e)} data-team="home" disabled maxLength={2} pattern="^[0-9\s]+$" />
                          </div>
                        )
                        : (
                          <div className="ar__predictions__match__score__scoreboard__box">
                            <input style={{pointerEvents: 'none'}} type="text" name="scoreboard" data-team="home" disabled onChange={(e) => handleInputChange(e)} maxLength={2} pattern="^[0-9\s]+$" />
                          </div>
                        )
                      }
                      <div className="ar__predictions__match__score__scoreboard__text">
                        <p className='black_30'>vs</p>
                      </div>
                      {match.away
                        ? (
                          <div className="ar__predictions__match__score__scoreboard__box">
                            <input style={{pointerEvents: 'none'}} data-initial={`${match.away}`} type="text" name="scoreboard" onChange={(e) => handleInputChange(e)} data-team="away" disabled maxLength={2} pattern="^[0-9\s]+$" />
                          </div>
                        )
                        : (
                          <div className="ar__predictions__match__score__scoreboard__box">
                            <input style={{pointerEvents: 'none'}} type="text" name="scoreboard" data-team="away" disabled onChange={(e) => handleInputChange(e)} maxLength={2} pattern="^[0-9\s]+$" />
                          </div>
                        )
                      }
                    </div>
                  </form>
                  <div className="ar__predictions__match__score__bottom whiteShadow">
                    <p className='black_20'>ingresa un marcador</p>
                  </div>
                </div>

                {/* ESTADO EN VIVO */}
                <div className="ar__predictions__match__score live">
                  <div className="ar__predictions__match__score__header">
                    <p className="ar__predictions__match__score__league black_20 opacity">
                      {match.season_name}
                    </p>
                    <p className="ar__predictions__match__score__state subtitleSmall">
                      en curso
                    </p>
                  </div>
                  <div className="ar__predictions__match__score__scoreboard">
                    {
                      match.home
                        ? (
                          <>
                            <p className='black_20 opacity'>tu predicción</p>
                            <div className="ar__predictions__match__score__scoreboard__row">
                              <p className='subtitleSmall yellowShadow'>
                                {match.home}
                              </p>
                              <p className='black_30 '>
                                vs
                              </p>
                              <p className='subtitleSmall yellowShadow'>
                                {match.away}
                              </p>
                            </div>
                          </>
                        )
                        :
                        <p className="ar__predictions__notPrediction">Sin predicción</p>
                    }
                  </div>
                  <div className="ar__predictions__match__score__bottom">
                    <div className="ar__predictions__match__score__bottom__bg">
                      <img src={`${defPath}/assets/images/predictions/bgMarcador.png`} alt="" />
                    </div>
                    <p className='black_20'>marcador parcial</p>
                  </div>
                </div>

                {/* equipo visitante */}
                <div className="ar__predictions__match__box">
                  <div className="ar__predictions__match__team">
                    <img src={`${match.team_away_image}`} alt={match.team_away_name} title={match.team_away_name} />
                    <div className="ar__predictions__match__team__name">
                      <p className='smallText opacity' data-nameteam='away'>{match.team_away_name}</p>
                    </div>
                  </div>
                  { match.goal_away &&
                    <div className="ar__predictions__match__point">
                      <p className='title_2' data-nameteam='away'>
                        {match.goal_away}
                      </p>
                    </div>
                  }
                </div>
              </div>
            </div>
          )
          )
        }
      </div>
      {/* CARDS CARDS CARDS */}
      <div className="ar__predictions__save">
        <div className="ar__predictions__save__actions">
          <button 
            type="button" 
            className="newBottom--smallYellow" 
            onClick={() => handlePredictionPost(predictions)}
            disabled={loading}
          >
            guardar marcadores
          </button>
        </div>
      </div>
    </>
  )
}

export default Predict
